var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 21.0557L2.64508 12.357C2.28268 11.972 2.28268 11.3713 2.64508 10.9863L10.832 2.28766",
    stroke: "#FF6B00",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-back.9c1e5258.svg";
export { SvgArrowBack as ReactComponent };